import { render, staticRenderFns } from "./importExam.vue?vue&type=template&id=4bd12fda"
import script from "./importExam.vue?vue&type=script&lang=js"
export * from "./importExam.vue?vue&type=script&lang=js"
import style0 from "./importExam.vue?vue&type=style&index=0&id=4bd12fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports